module.exports = __webpack_public_path__ + "assets/img/3.2d0cdf69.png";